import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useBackend } from "../backend/BackendProvider";
import { mutationContext } from "../backend/mutation";
import { useToast } from "../components/ToastProvider";
import { readOfflineQueue, writeOfflineQueue, writeRecentSnapshot } from "./offline";

export function OfflineSyncEngine() {
  const backend = useBackend(); const queryClient = useQueryClient(); const { show } = useToast();
  const tasks = useQuery({ queryKey: ["offline-snapshot", "tasks"], queryFn: () => backend.tasks.list(undefined, "updated", { limit: 100 }), refetchInterval: 60_000 });
  const projects = useQuery({ queryKey: ["offline-snapshot", "projects"], queryFn: () => backend.projects.list(undefined, "updated", { limit: 100 }), refetchInterval: 60_000 });
  useEffect(() => { if (tasks.data && projects.data) writeRecentSnapshot(tasks.data.items, projects.data.items); }, [projects.data, tasks.data]);
  useEffect(() => {
    let syncing = false;
    const sync = async () => {
      const queue = readOfflineQueue(); if (!navigator.onLine || !queue.length || syncing) return;
      syncing = true; const remaining = [...queue]; let synced = 0;
      for (const item of queue) {
        try { await backend.tasks.create(item.input, mutationContext()); remaining.splice(remaining.findIndex((entry) => entry.id === item.id), 1); synced += 1; writeOfflineQueue(remaining); }
        catch { break; }
      }
      syncing = false;
      if (synced) { await queryClient.invalidateQueries(); show(`${synced} offline ${synced === 1 ? "change" : "changes"} synced${remaining.length ? `; ${remaining.length} still waiting` : ""}.`); }
    };
    window.addEventListener("online", sync); void sync(); return () => window.removeEventListener("online", sync);
  }, [backend, queryClient, show]);
  return null;
}
